import script from "./PinGoodsSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PinGoodsSelector.vue?vue&type=script&setup=true&lang=js"

import "./PinGoodsSelector.vue?vue&type=style&index=0&id=f12f69c0&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\万禾项目\\东智\\dongzhistore\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12f69c0"]])

export default __exports__